// extracted by mini-css-extract-plugin
export default {"root":"_35e6m","custom-icon-button-size":"_2DAsS","customIconButtonSize":"_2DAsS"};